import * as React from 'react';
import { memo } from 'react';

const SvgEye = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { clipRule: "evenodd", d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgEye);

export { Memo as default };
